import React from 'react';

import { Button, Container, Grid, Link, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  backButton: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20,
  },
  container: {
    minHeight: 300,
    minWidth: 600,
    padding: 40,
  },
  continueButton: {
    height: 40,
    width: 160,
  },
  continueContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20,
  },
  description: {
    marginTop: 20,
  },
}));

export default ({ onCancelClick, onContinueClick }) => {
  const classes = useStyles();

  const handleCancelClick = (event) => {
    if (onCancelClick) onCancelClick();
    event.preventDefault();
    return false;
  };

  return (
    <Container maxWidth="xs" disableGutters className={classes.container}>
      <Grid container justify="center" alignItems="center">
        <Grid item xs={12}>
          <Typography variant="h4" align="center">
            You have not selected any files
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.description}>
          <Typography variant="body1" align="center" style={{ color: 'rgba(177, 42, 42, 1)' }}>
            Do note that any unselected files will be removed from our system and will not be viewable from this point on.
          </Typography>
        </Grid>
        <Grid item xs={12} className={classes.continueContainer}>
          <Button variant="contained" color="primary" size="medium" className={classes.continueButton} onClick={onContinueClick}>
            Continue
          </Button>
        </Grid>
        <Grid item xs={12} className={classes.backButton}>
          <Link color="primary" href="#" style={{ fontSize: 20 }} onClick={handleCancelClick}>
            Back to file selection
          </Link>
        </Grid>
      </Grid>
    </Container>
  );
};
